<template>
  <main class="main">
    <section class="section">
      <div class="welcome">
        <img src="../../assets/images/logo-main.png" alt="logo" />
        <p>예천박물관에 오신 것을 환영합니다</p>
      </div>
      <div class="icon_container">
        <router-link :to="{ name: 'AntiquityId', params: { id: 53 } }">
          <img src="../../assets/images/icon.png" alt="icon" />
        </router-link>
        <p>아이콘을 터치하여</p>
        <p>스마트 예천박물관을 체험해 보세요.</p>
      </div>
    </section>
  </main>
</template>

<style scoped>
.main {
  width: 100%;
  height: 100%;
  background: url("../../assets/images/bg-main.png");
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99999;
}
.section {
  width: 100%;
  height: 100%;
  max-height: 100vh;
  background: url("../../assets/images/red.png");
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 8rem 0;
}
.welcome {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 20rem;
}
.welcome img {
  width: 9rem;
}
.welcome p {
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.2px;
  margin-top: 1rem;
  color: #3c2415;
}

.icon_container {
  margin: 0 auto;
  width: 20rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.icon_container img {
  width: 4rem;
  margin-bottom: 1rem;
}
.icon_container p {
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.2px;
  color: #e01746;
}
</style>
